import ApiService from '../api.services';

const RequestInfoService = {
  list: async function (customers, startedAt, finishedAt, records, page, tag, status) {
    try {
      const response = await ApiService.get(`/api/requestinfo?customers=${customers.join(',')}&startedAt=${startedAt}&finishedAt=${finishedAt}&records=${records}&page=${page}&tag=${tag}&status=${status}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  reason: async function () {
    try {
      const response = await ApiService.get(`/api/requestinfo/reason/list`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  upload: async function (file) {
    try {
      let formData = new FormData();
      formData.append(`files[0]`, file.raw);
      console.log(formData, file);
      const response = await ApiService.post(`/api/requestinfo/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (data) {
    try {
      const response = await ApiService.post(`/api/requestinfo`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  statustag: async function (data) {
    try {
      const response = await ApiService.post(`/api/requestinfo/status/tag`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  status: async function (data) {
    try {
      const response = await ApiService.post(`/api/requestinfo`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  detail: async function (protocol) {
    try {
      const response = await ApiService.get(`/api/requestinfo/request/query/${protocol}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default RequestInfoService;

export { RequestInfoService };

